import API from '../../API.js';
const chalk = require("chalk");
import {table} from 'table';

exports.command = 'list'
exports.desc = 'List the sites for which you have access.'
exports.builder = function (yargs) {

  const epilog = chalk.dim("Darwin Command Line Interface\nCopyright 2019 Darwin Inc. All Rights Reserved.\n")

  return yargs
    .usage('Usage:\ndarwincli site list')
    .help()
    .epilog(epilog)
}

exports.handler = function (argv) {
  API.clientCallDarwinAPI("GET", "sites", {}, [], (result, data) => {
    if (!result) {
      return
    }
    console.log(chalk("You have access to the following sites.\n" + chalk.bold.blue("Use a site's 'id' when performing an operation on it.")))

    let tdata = [["id", "name", "url", "description"]]
    for (let i = 0; i < data.length; i = i + 1) {
      let val = [data[i].id, data[i].name, data[i].url, data[i].description]
      tdata.push(val)
    }

    let options = {
      columns: {
        0: {
          width: 5
        },
        1: {
          width: 15
        },
        2: {
          width: 25
        },
        3: {
          width: 20
        }
      }
    };

    let output = table(tdata, options);
    console.log(output);
  }, process.env.DARWIN_CLIENT_ID, process.env.DARWIN_CLIENT_SECRET)
}
